import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import { MutateRowForm } from '../components'
import { ConfirmModal, ServiceModal } from 'components/Modal'
import { ReactComponent as Delete } from '../../shared/icons/delete.svg'
import { ReactComponent as Loading } from 'media/icons/loading.svg'
import { ReactComponent as Edit } from '../edit.svg'
import styles from '../DataTable.module.scss'

const withMutateRow = WrappedComponent => {
	class MutateRowWrapper extends Component {
		state = {
			editingRowData: null,
			showWaitModal: false
		}

		setEditingRow = (row, callback) => this.setState({ editingRowData: row }, callback)

		render({ mutateRow, getTrProps, columns, ...rest } = this.props) {
			const { beforeRowMutate, isMutating, toggleMutation, disableEditing, deleteBtns, ...restMutateRow } = mutateRow
			let columnsWithDelete = [...columns]
			// Display del buttons only in rows from 'deleteBtns' array if it's provided
			const hideDelBtn = rowId => deleteBtns ? { ...!deleteBtns.find(id => Number(id) === Number(rowId)) && { visibility: 'hidden' } } : {}
			if(!mutateRow.disableDeleting) {
				columnsWithDelete.push({
					accessor: 'deleting',
					Cell: ({ original }) => (
						<Fragment>
							{mutateRow.editBtn &&
								<Edit
									onClick={e => {
										e.stopPropagation()
										handleChangeData(original)
									}}
									className={styles['btn-edit']}
								/>
							}
							<Delete
								style={hideDelBtn(original.id)}
								className={styles['btn-del']}
								onClick={e => {
									e.stopPropagation(); handleDel(original.id, beforeRowMutate)
								} } />
						</Fragment>
					),
					width: 'auto',
					className: 'cell-del',
					headerClassName: 'cell-del',
					sortable: false,
					resizable: false,
					...mutateRow.colProps
				})
			}
			const handleChangeData = vals => {
				let toggleInParent = true
				this.setEditingRow(null)
				if(mutateRow.onRowMutate) {
					mutateRow.onRowMutate(vals)
				}
				if(vals) {
					if(vals.id) {
						// console.log('Mutation update')
						// Mutation update data
					} else if(typeof vals === 'string' || typeof vals === 'number') {
						toggleInParent = false
						// console.log('Mutation delete')
						// Mutation delete data
					} else {
						// console.log('Mutation add')
						// Mutation add data
					}
				}
				if(toggleInParent && typeof mutateRow.toggleMutation === 'function') {
					toggleMutation()
				}
			}
			const handleDel = async (id, callback) => {
				const showConfirm = (confirmOptions = {}) => {
					ConfirmModal(confirmOptions).then(
						confirmed => handleChangeData(id),
						rejected => null
					)
				}
				if(callback) {
					this.setState({ showWaitModal: true }, async () => {
						const confirmOptions = await callback(id)
						// Replace waiting modal with confirm one only if waiting modal wasn't closed during callback execution
						if(this.state.showWaitModal) {
							showConfirm(confirmOptions)
							this.setState({ showWaitModal: false })
						}
					})
				} else {
					showConfirm()
				}
			}
			const AdditionaTrProps = (state, rowInfo) => {
				const trProps = getTrProps ? getTrProps(state, rowInfo) : {}
				return {
					...trProps,
					onDoubleClick: (e) => {
						if(!disableEditing) {
							this.setEditingRow(rowInfo.original, () => toggleMutation ? toggleMutation() : null)
						}
					}
				}
			}
			return(
				<Fragment>
					<WrappedComponent {...rest} columns={columnsWithDelete} getTrProps={AdditionaTrProps}/>
					{isMutating &&
						<MutateRowForm
							data={this.state.editingRowData}
							columns={columns.map(col =>
								col.accessor === 'id' ? { ...col, show: true } : col)
								.filter(col => col.show)}
							onChangeRow={handleChangeData}
							{...restMutateRow}
						/>
					}
					{this.state.showWaitModal &&
						<ServiceModal label='' text={<Loading className='loading-indicator' />} onClose={() => this.setState({ showWaitModal: false })} />
					}
				</Fragment>
			)
		}
	}
	MutateRowWrapper.propTypes = {
		getTrProps: PropTypes.func,
		columns: PropTypes.array.isRequired,
		editRow: PropTypes.bool, // Enables editing row by double clicking
		mutateRow: PropTypes.shape({
			beforeRowMutate: PropTypes.func, // Async func executed before rendering 'ConfirmModal'. Can return props for 'ConfirmModal'.
			onRowMutate: PropTypes.func,
			isMutating: PropTypes.bool,
			toggleMutation: PropTypes.func, // Function in parent component toggling 'mutateRow.isMutating' to opposite
			colProps: PropTypes.object,
			deleteBtns: PropTypes.array, // Delete buttons will be displayed only in rows with provided ids
			editBtn: PropTypes.bool // Show edit icon in rows
		}).isRequired
	}
	return MutateRowWrapper
}

export default withMutateRow

